import { render, staticRenderFns } from "./subExpertSign.vue?vue&type=template&id=35ae9480&scoped=true"
import script from "./subExpertSign.vue?vue&type=script&lang=js"
export * from "./subExpertSign.vue?vue&type=script&lang=js"
import style0 from "./subExpertSign.vue?vue&type=style&index=0&id=35ae9480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ae9480",
  null
  
)

export default component.exports